

export default function deleteResearchQueryPreset({delete_}: any, id: string): Promise<any> {
  return delete_(`/comparable-sale-query-presets`, {id}, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/researchQueryPresets/deleteResearchQueryPreset.tsx